import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import grey from '@material-ui/core/es/colors/grey';
import Drawer from '@material-ui/core/Drawer';
import {
  Business,
  DirectionsBus,
  DirectionsRailway,
  GetApp,
  Person,
  PowerSettingsNew,
  RestorePage,
  Timeline,
} from '@material-ui/icons';

import IconButton from '@material-ui/core/IconButton';

import bars from './bars';
import modules from './modules';

const styles = {
  iconBar: {
    container: {
      width: 60,
      zIndex: 1200,
    },
    bar: {
      width: 60,
      height: '100%',
      position: 'absolute',
      top: 65,
      marginTop: -65,
      backgroundColor: grey[100],
      zIndex: 1203,
      textAlign: 'center',
      left: 0,
    },
    iconMenu: {
      paddingTop: 70,
    },
    logout: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      bottom: 0,
    },
  },
};

class LeftBar extends Component {
  static propTypes = {
    // state props
    bar: PropTypes.string,
    extra: PropTypes.shape({}),
    isAdmin: PropTypes.bool.isRequired,
    isSubcontractor: PropTypes.bool.isRequired,
    module: PropTypes.string,
    open: PropTypes.bool.isRequired,

    // dispatch props
    closeLeftBar: PropTypes.func.isRequired,
    closeLeftBarModule: PropTypes.func.isRequired,
    destroy: PropTypes.func.isRequired,
    openLeftBar: PropTypes.func.isRequired,
    openLeftBarModule: PropTypes.func.isRequired,
  };

  static defaultProps = {
    bar: null,
    module: null,
    extra: null,
  };

  handleToggleLeftBar = (bar) => {
    const { closeLeftBar, openLeftBar } = this.props;

    if (this.props.bar === bar) {
      closeLeftBar();
    } else {
      openLeftBar(bar);
    }
  };

  handleToggleLeftBarModule(bar, module, extra) {
    if (this.props.bar === bar &&
        this.props.module === module)
      this.props.closeLeftBarModule(bar);
    else
      this.props.openLeftBarModule(bar, module, extra);
  }

  render() {
    const {
      bar, classes, destroy, extra, module,
      open, isAdmin, isSubcontractor,
    } = this.props;

    const SelectedBar = bar && bars[bar];
    const SelectedModule = module && modules[module];

    return (
      <div>
        <div style={styles.iconBar.container}>
          <div style={styles.iconBar.bar}>
            <div style={styles.iconBar.iconMenu} className="IconMenuLeft">
              <div onClick={() => this.handleToggleLeftBar('routeBlockage')}>
                <IconButton component="span">
                  <Timeline />
                </IconButton>
              </div>

              <div onClick={() => this.handleToggleLeftBar('company')}>
                <IconButton component="span">
                  <Business />
                </IconButton>
              </div>

              <div onClick={() => this.handleToggleLeftBar('bus')}>
                <IconButton component="span">
                  <DirectionsBus />
                </IconButton>
              </div>

              {(isAdmin || isSubcontractor) && (
                <div onClick={() => this.handleToggleLeftBar('apiUser')}>
                  <IconButton component="span">
                    <Person />
                  </IconButton>
                </div>
              )}

              {isAdmin && (
                <div onClick={() => this.handleToggleLeftBar('RideAdmin')}>
                  <IconButton component="span">
                    <RestorePage />
                  </IconButton>
                </div>
              )}

              {isAdmin && (
                <div onClick={() => this.handleToggleLeftBar('railwayAdmin')}>
                  <IconButton component="span">
                    <DirectionsRailway />
                  </IconButton>
                </div>
              )}

              {(isAdmin || isSubcontractor) && (
                <div onClick={() => this.handleToggleLeftBar('RideExport')}>
                  <IconButton component="span">
                    <GetApp />
                  </IconButton>
                </div>
              )}

              <div onClick={() => destroy()} style={styles.iconBar.logout}>
                <IconButton component="span">
                  <PowerSettingsNew />
                </IconButton>
              </div>
            </div>
          </div>
        </div>

        <Drawer
          classes={{ root: classes.barDrawerRoot }}
          open={open}
          PaperProps={{ classes: { root: classes.barDrawerPaper }}}
          ModalProps={{ hideBackdrop: true }}
        >
          {SelectedBar &&
            <SelectedBar
              bar={bar}
              module={module}
              extra={extra}
              handleToggleLeftBar={() => this.handleToggleLeftBar(bar)}
              handleToggleLeftBarModule={(module, extra) => this.handleToggleLeftBarModule(bar, module, extra)}
              isAdmin={isAdmin}
              isSubcontractor={isSubcontractor}
            />
          }
        </Drawer>

        <Drawer
          classes={{ root: classes.moduleDrawerRoot }}
          open={!!module}
          PaperProps={{ classes: { root: classes.moduleDrawerPaper }}}
        >
          {SelectedModule && <SelectedModule extra={extra} />}
        </Drawer>
      </div>
    )
  }
}

export default withStyles({
  barDrawerRoot: {
    width: 250,
  },
  barDrawerPaper: {
    width: 250,
  },
  moduleDrawerRoot: {
    zIndex: '1201 !important',
  },
  moduleDrawerPaper: {
    backgroundColor: grey[100],
    marginLeft: 250,
    marginTop: 65,
    width: 'calc(100% - 250px)', // full width minus leftBar width
    height: 'calc(100% - 65px)', // full height minus header height
  },
})(LeftBar);
